import React from "react";
import { Filter } from "lucide-react";
import "./SearchFilter.css";

const FilterButton = ({ active = false, open = false, onClick, children = "Filters" }) => (
  <button
    type="button"
    className={`zarp-filter-button ${active ? "is-active" : ""} ${open ? "is-open" : ""}`.trim()}
    onClick={onClick}
    aria-expanded={open}
  >
    <Filter size={17} />
    <span>{children}</span>
  </button>
);

export default FilterButton;
